export const BREAKPOINT_COLS = {
  1024: 1,
  1280: 2,
  1536: 3,
  default: 4
};
